import HomeComponent from '../components/home.jsx'

const Home = () => <HomeComponent />

export default Home;